export var COLORS = {
    BLUE: {
        100: '#ccecf9',
        200: '#99d9f4',
        300: '#66c7ee',
        400: '#33b4e9',
        500: '#00A1E3',
        600: '#0081b6',
        700: '#006188',
        800: '#00405b',
        900: '#00202d',
    },
    GRAY: {
        25: '#fbfbfb',
        50: '#f6f6f6',
        100: '#e1e1e1',
        200: '#cccccc',
        300: '#b7b7b7',
        400: '#a1a1a1',
        500: '#8c8c8c',
        600: '#747474',
        700: '#5c5c5c',
        800: '#343434',
        900: '#272727',
    },
    GREEN: {
        500: '#73C37A',
        400: '#8FCF95',
        300: '#ABDBAF',
        200: '#C7E7CA',
        100: '#E3F3E4',
    },
    ORANGE: {
        500: '#FFBD00',
        400: '#FFCA33',
        300: '#FFD766',
        200: '#FFE599',
        100: '#FFF2CC',
    },
    RED: {
        500: '#D95562',
        400: '#E17781',
        300: '#E899A1',
        200: '#F0BBC0',
        100: '#F7DDE0',
        50: '#FBEEEF',
    },
    WHITE: '#FFF',
    BLACK: '#000',
    PRIMARY: {
        500: '#5E58F8',
        400: '#7e79f9',
        300: '#9e9bfb',
        200: '#bfbcfc',
        100: '#dfdefe',
        50: '#efeefe',
        25: '#f5f5ff',
    },
    SECONDARY: {
        500: '#00A1E3',
        300: '#66c7ee',
    },
};
